// extracted by mini-css-extract-plugin
export default {"popupBox":"Popup_popupBox__aoCen","wrapper":"Popup_wrapper__7RbVB","closeIcon":"Popup_closeIcon__CsRyj"};